import { DestructuredURL, APIClient, serializeFormdata } from "@utils";
import * as React from 'react'
import * as styles from './FallbackForm.module.scss'

interface FallbackFormProps<T> {
    endpointUrl: DestructuredURL
    children: React.ReactChild | React.ReactChild[]
    onSuccess?: ((out: T) => void)[]
    onError?: ((err: Error) => void)[]
}


export class FallbackForm<T> extends React.Component<FallbackFormProps<T>> {
    sendToggleRequest = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        const query = this.props.endpointUrl.query
        const params = serializeFormdata(query)
        const api = new APIClient
        api.call(this.props.endpointUrl.partialURL, {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-requested-with': 'XMLHttpRequest' // must be there for WPS not to do the redirect
            },
            body: params
        }).then((out: T) => {
            this.props.onSuccess && this.props.onSuccess.forEach(f => f(out))
        }).catch((err: Error) =>
            this.props.onError && this.props.onError.forEach(f => f(err))
        )
    }

    queryAsHiddenInputs(query: { [key: string]: string }) {
        const hiddenInputs = []
        for (const key in query) {
            if (query.hasOwnProperty(key)) {
                hiddenInputs.push(<input type="hidden" name={key} defaultValue={query[key]} key={key} />)
            }
        }
        return hiddenInputs
    }

    render() {
        return <form onSubmit={this.sendToggleRequest}
            action={this.props.endpointUrl.partialURL} method="POST"
            className={styles.falseForm}>
            {this.queryAsHiddenInputs(this.props.endpointUrl.query)}
            <button type="submit" className={styles.falseButton}>
                {this.props.children}
            </button>
        </form>

    }
}